import React from 'react'
import PropTypes from 'prop-types'
import withStyles from '@material-ui/core/styles/withStyles'
import withWidth, { isWidthUp } from '@material-ui/core/withWidth'

import Container from '@material-ui/core/Container'
import GridContainer from '@naturacosmeticos/natds-web/dist/Components/GridContainer'
import GridItem from '@naturacosmeticos/natds-web/dist/Components/GridItem'
import Typography from '@material-ui/core/Typography'

import { FormattedHTMLMessage, injectIntl } from 'react-intl'
import HeroCard from './HeroCard'
import styles from './Hero.styles'
import intlPropTypes from '../../types/intlPropTypes'
import RegisterCTA from '../../components/RegisterCTA'

const PureHero = ({ width, classes, heroImage, intl, ctaOnClick, isEloThemeActive, ...props }) => {
  return (
    <section {...props}>
      {isWidthUp('md', width) ? (
        <Container component="article">
          <GridContainer
            className={classes.container}
            alignItems="center"
            justify="center"
          >
            <GridItem md={8} lg={8}>
              {heroImage}
            </GridItem>
            <GridItem md={4} lg={4}>
              <HeroCard ctaOnClick={ctaOnClick} isEloThemeActive={isEloThemeActive}/>
            </GridItem>
          </GridContainer>
        </Container>
      ) : (
        <GridContainer direction="column">
          <GridItem sm={12}>
            <div className={classes.heroImageOverlay}>{heroImage}</div>
            <Typography
              className={classes.heroCardHeader}
              component="h2"
              variant="h5"
            >
              <FormattedHTMLMessage id="homeHeroTitle" />
            </Typography>
          </GridItem>
          <GridItem
            sm={12}
            classes={{ root: classes.heroMobileDescriptionBlock }}
          >
            <Typography
              className={classes.heroCardDescription}
              component="p"
              variant="body1"
            >
              <FormattedHTMLMessage id="homeHeroSubtitle" />
            </Typography>
            <RegisterCTA
              id="hero-mobile-cta-button"
              aria-label={intl.formatMessage({
                id: 'homeHeroCTAButtonAccessibleLabel'
              })}
              className={classes.heroButton}
              data-gtm-category="landing_hero"
              data-gtm-main-action="click"
              data-gtm-label={intl.formatMessage({
                id: 'homeHeroCTAButtonText'
              })}
              data-gtm-category-ga4="landing_hero"
              data-gtm-main-action-ga4="click"
              data-gtm-label-ga4={intl.formatMessage({
                id: 'homeHeroCTAButtonText'
              })}
              isEloThemeActive={isEloThemeActive}
              data-testid="hero-register-cta-button-mobile"
              label={intl.formatMessage({ id: 'homeHeroCTAButtonText' })}
              href={intl.formatMessage({ id: 'ctaButtonLinkMobile' })}
            />
          </GridItem>
        </GridContainer>
      )}
    </section>
  )
}

PureHero.propTypes = {
  classes: PropTypes.shape({
    container: PropTypes.string,
    heroButton: PropTypes.string,
    heroCardDescription: PropTypes.string,
    heroCardHeader: PropTypes.string,
    heroImageOverlay: PropTypes.string,
    heroMobileDescriptionBlock: PropTypes.string
  }),
  heroImage: PropTypes.node.isRequired,
  intl: PropTypes.shape(intlPropTypes),
  ctaOnClick: PropTypes.func,
  isEloThemeActive: PropTypes.bool
}
const HeroWithIntl = injectIntl(PureHero)
const HeroWithStyles = withStyles(styles)(HeroWithIntl)
const Hero = withWidth({ initialWidth: 'sm' })(HeroWithStyles)

export default Hero
